try {
  JSON.parse(localStorage.myWishlist)
} catch (e) {
  localStorage.myWishlist = "[]"
}

var wishlistMenu = null;

function openWishlist(){
  var overlay = document.getElementById("wishlist-overlay")
  //var drawer = document.getElementById("wishlist-drawer")
  overlay.classList.remove("closed")
  //drawer.classList.remove("closed")
  if(!wishlistMenu._isOpened){
    wishlistMenu.open()
  }
}

function closeWishlist(){
  var overlay = document.getElementById("wishlist-overlay")
  // var drawer = document.getElementById("wishlist-drawer")
  overlay.classList.add("closed")
  // drawer.classList.add("closed")
  if(wishlistMenu._isOpened){
    wishlistMenu.close()
  }
}

function getWishlistPosition(id){
  var arr = JSON.parse(localStorage.myWishlist)
  var idP = -1
  arr.map((p, idA) => {
    if(p.product.id == id){
      idP = idA
    }
  })
  return idP
}

function removeFromWishlist(id_prod){
  var arr = JSON.parse(localStorage.myWishlist)
  arr.splice(getWishlistPosition(id_prod), 1)
  localStorage.myWishlist = JSON.stringify(arr)
  updateWishlist()
  
  const event = new CustomEvent("remove-fromwishlist", { detail: {id: id_prod }});
  window.dispatchEvent(event)
}

function heartEffect(){
  document.getElementById("header").parentNode.style.top = "0px";
  var redHeart = document.getElementById("wishlist-menu-heart-red")
  redHeart.classList.add("heart-beat")
  setTimeout(() => {
    redHeart.classList.remove("heart-beat")
  }, 1000)
}

function updateWishlist(){
  var list = JSON.parse(localStorage.myWishlist)
  var wlist = document.getElementById("wishlist-list")
  wlist.innerHTML = ""
  list.map((p) => {
    var container = document.createElement("div")
    container.className = "product-cart-item"
    var imgContainer =  document.createElement("img")
    imgContainer.className = "product-img"
    imgContainer.src =  p.img
    var centralDiv = document.createElement("div")
    centralDiv.className = "wishlist-title"
    var title = document.createElement("a")
    title.className = "cart-product-link"
    title.innerHTML = p.product.name.split(" - ")[0]
    title.href = "/products/" + p.handle + "?variant=" + p.product.id
    var subtitle = document.createElement("a")
    subtitle.className = "cart-subproduct-link"
    subtitle.innerHTML = p.product.name.split(" - ")[1]
    subtitle.href = "/products/" + p.handle + "?variant=" + p.product.id
    var price = document.createElement("div")
    price.className = "cart-subproduct-link"
    price.innerHTML = (p.product.price / 100).toFixed(2).replace(".", ",") + " " + document.getElementById("currency-symbol").innerHTML
    centralDiv.appendChild(title)
    centralDiv.appendChild(subtitle)
    centralDiv.appendChild(price)
    var remove = document.createElement("button")
    remove.className = "wishlist-remove"
    remove.innerHTML = '<svg product="' + p.product.id + '" width="18" height="18" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3L1 3M5.00024 6V10M8.00024 6V10M11.0002 3V12.5C11.0002 12.6326 10.9476 12.7598 10.8538 12.8536C10.76 12.9473 10.6329 13 10.5002 13H2.50024C2.36764 13 2.24046 12.9473 2.14669 12.8536C2.05292 12.7598 2.00024 12.6326 2.00024 12.5V3M9.00025 3V2C9.00025 1.73478 8.89489 1.48043 8.70735 1.29289C8.51982 1.10536 8.26546 1 8.00024 1H5.00024C4.73503 1 4.48067 1.10536 4.29314 1.29289C4.1056 1.48043 4.00024 1.73478 4.00024 2V3" stroke="#E93636" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
    remove.addEventListener("click", () => removeFromWishlist(p.product.id))
    
    container.appendChild(imgContainer)
    container.appendChild(centralDiv)
    container.appendChild(remove)
    wlist.appendChild(container)
  })

  if(list.length == 0){
    var empty = document.createElement("div")
    empty.style.textAlign = "center"
    empty.className = "cart-product-link wishlist-title"
    empty.innerHTML = document.getElementById("wishlist-empty").innerHTML
    wlist.appendChild(empty)
    document.getElementById("wishlist-bubble").innerHTML = ""
    document.getElementById("wishlist-bubble").style = "display: none"
  }else{
    document.getElementById("wishlist-bubble").innerHTML = list.length
    document.getElementById("wishlist-bubble").style = ""
  }
}

window.addEventListener('DOMContentLoaded', (event) => {
    var drawer = document.getElementById("wishlist-drawer")
    drawer.style = ""
    updateWishlist()

    wishlistMenu = new MobileSwipeMenu('#wishlist-drawer', {
        mode: 'right',
        width: window.innerWidth - 30 > 480 ? 480 : window.innerWidth - 30,
        hookWidth: 15,
        events: {
          opening: function () {
            openWishlist()
          },
          closed: function () {
            closeWishlist()
          }
        }
    });
});

window.addEventListener("resize", () => {
  var menuW = window.innerWidth - 30 > 480 ? 480 : window.innerWidth - 30
  wishlistMenu.setWidth(menuW)
  wishlistMenu._windowWidth = window.innerWidth
});